module.exports = __webpack_public_path__ + "img/signal-stream-slash.22512328.svg";